import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-P8DZSK',
        },
    },
    host: 'www.zalando-prive.it',
});
